import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';

// La sesión ya se intentó restaurar en el arranque (provideAppInitializer). Sin sesión →
// /login, con la ruta de vuelta.
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.autenticado()) return true;
  return router.createUrlTree(['/login'], { queryParams: { volver: state.url } });
};
